var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.categories")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("div", { staticClass: "col-md-12 no-padding" }, [
            _c(
              "table",
              {
                staticClass: "table table-bordered",
                staticStyle: { width: "100%" },
                attrs: { id: "dataTable" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.category")))]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center",
                        staticStyle: { width: "150px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.assignitems")))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.categories, function(item, index) {
                    return _c("tr", [
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "CategoryEdit",
                                  query: {
                                    cat_id: item.category_id,
                                    cat_name: item.category_name
                                  }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.category_name) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "150px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.assign.length) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62780c88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62780c88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/items/category/All.vue
// module id = null
// module chunks = 